import {
    makeSelectMyTimesheetEntryCreatedByUserId,
    makeSelectMyTimesheetEntryLastReviewedAt
} from 'services/myTimesheetEntries/selectors';
import { makeSelectUsersMeValue } from 'services/usersMe/selectors';
import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';

const selectMyTimesheetEntryIsEditable = createDeepEqualSelector(
    makeSelectMyTimesheetEntryCreatedByUserId(),
    makeSelectUsersMeValue('id'),
    makeSelectMyTimesheetEntryLastReviewedAt(),
    (createdByUserId, userId, lastReviewedAt) => {
        if (lastReviewedAt) {
            return false;
        }

        return Boolean(userId && createdByUserId && userId === createdByUserId);
    }
);

const makeSelectMyTimesheetEntryIsEditable = (): typeof selectMyTimesheetEntryIsEditable =>
    selectMyTimesheetEntryIsEditable;

export { makeSelectMyTimesheetEntryIsEditable };
